import { CreateService, CRUDServiceInterface } from '@/services/service';
import { LessonCategoryEntity } from '@/entities/lesson-category.entity';

export default class LessonCategoryService
  extends CreateService<LessonCategoryEntity>('lesson-category')
  implements CRUDServiceInterface<LessonCategoryEntity>
{
  async getMany(): Promise<LessonCategoryEntity[]> {
    const [items] = await this.apiBuilder.getMany();
    return items;
  }
}
